const quantity = (state = 1, action) => {
    switch(action.type) {
        case 'quantity':
            return action.payload;
        default:
            return state;
    }
}

export default quantity;